import React from "react";
import { Text, HistorySelector, FrameIcon, Selector } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { config } from "../../../config/config";
import { HistoryListWrapper, HistoryWrapper, HeaderText, StepText } from "../styles/Styled";

const purchaseDate = (d, description) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const dateFormate = new Date(d.replace(/ /, "T"));
  const parseDate = Date.parse(dateFormate);

  const dateObj = new Date(parseDate);
  const monthIndex = dateObj.getMonth();
  const monthName = monthNames[monthIndex];
  const year = dateObj.getFullYear();
  const day = dateObj.getDate();
  return `${day} ${monthName}, ${year}\u00A0\u00A0\u00A0(${i18n.get(`pages.settings.history.${description}`)})`;
};

const purchasePrice = item => {
  const currency = item.currency;
  const amount = item.amount;
  return `${currency} ${amount}`;
};
const profileName = profileName => {
  return `${i18n.get(`pages.profileName.profileNameHeader`)}: ${profileName}`;
};

export const History = ({ historylist, isFromSettingsPage, confirmationOptions, onItemSelected, isBottonShowing }) => {
  return (
    <>
      {historylist && (!historylist.length || historylist.length === 0) ? (
        <HistoryWrapper>
          <FrameIcon name="storeLarge" alignSelf="start" />
          <Text rank="1" text={i18n.get(`pages.settings.history.heading`)} size="large" />
          <Text text={i18n.get(`pages.settings.history.paragraph1`)} type="primary" size="medium" />
          <Selector
            items={confirmationOptions}
            onItemSelected={onItemSelected}
            isFromSettingsPage={isFromSettingsPage}
            size={"xmedium"}
            textAlign="center"
          />
        </HistoryWrapper>
      ) : (
        <HistoryListWrapper>
          <FrameIcon name="history" alignSelf="start" />
          <HeaderText rank="1" className={"heading"} text={i18n.get(`pages.settings.history.title`)} size="large" />
          <StepText rank="2" text={i18n.get(`pages.settings.history.paragraph2`)} type="greyLight" size="small" />
          <HistorySelector
            items={historylist.map(item => ({
              key: `key_${item.id}`,
              date: purchaseDate(item.purchasedDate, item.subscriptionType),
              title: item.assetTitle.length > 35 ? item.assetTitle.slice(0, 35) + " ..." : item.assetTitle,
              //description: i18n.get(`pages.settings.history.${item.subscriptionType}`),
              price: purchasePrice(item),
              profileName: profileName(item.profileName)
            }))}
            onItemSelected={onItemSelected}
            selectedIndex={null}
            label={i18n.get(`pages.settings.history.bottomLabel`).toLocaleUpperCase()}
            isBottonShowing={isBottonShowing}
          />
        </HistoryListWrapper>
      )}
    </>
  );
};
